import "./index.scss";
import Tap from "../../assets/img/Green-Touch-Icon.gif";
import Logo from "../../components/icons/Logo";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../context/DataProvider";
import { Header } from "../../components/Header";
import Residence from "../../components/icons/NavIcons/Residence";
import CommonArea from "../../components/icons/NavIcons/CommonArea";
import Pool from "../../components/icons/NavIcons/Pool";

const ResidentialPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return (
      <div className="page splash2 residentialPage">
        <Header />
        <div className="page-header">Residential Building</div>
        <div className="text-blocks">
          <div className="std-text">
            Create a sense of home for residents by empowering them with
            flexible meal transaction options.{'\n\n'}
            From staff-operated enterprise class point-of-sale systems to
            self-service kiosks and mobile ordering, enhance resident and staff
            engagement in your community with world-class hospitality technology
            solutions.
          </div>
        </div>
        <div className="tap">
          <img src={Tap} alt="" />
          <div className="tap-prompt">
            Tap on each section of the map{"\n"}
            To drill into the details
          </div>
        </div>
        <div
          className="logo"
          onClick={() => {
            _logEvent("click", "Residential", "Agilysys");
            addFlow("Agilysys");
            navigate("/aboutus/agilysys");
          }}
        >
          <Logo />
        </div>
        <div className="residential-map">
          <div className="residence">
            <Residence
              onClick={() => {
                _logEvent("click", "Residential", "Residence");
                addFlow("Residence");
                navigate("residence", { relative: "path" });
              }}
            />
          </div>
          <div className="common">
            <CommonArea
              onClick={() => {
                _logEvent("click", "Residential", "Common Area");
                addFlow("Common Area");
                navigate("common", { relative: "path" });
              }}
            />
          </div>
          <div className="pool">
            <Pool
              onClick={() => {
                _logEvent("click", "Residential", "Pool");
                addFlow("Pool");
                navigate("pool", { relative: "path" });
              }}
            />
          </div>
        </div>
      </div>
    );
}
export default ResidentialPage;